"use client";

import { motion } from "framer-motion";

export interface ProblemSolutionBlockStyle {
    titleColor?: string;
    subtitleColor?: string;
    textColor?: string;
    backgroundColor?: string;
    paddingTop?: string;
    paddingBottom?: string;
}

export interface ChallengeItem {
    title: string;
    content: string;
}

export interface ProblemSolutionBlockProps {
    title: string;

    // challenges list
    challenges?: ChallengeItem[];

    // Legacy Props (Backward Compatibility)
    problemTitle?: string;
    problemContent?: string;
    solutionTitle?: string;
    solutionContent?: string;

    // Images
    mainImage?: string;
    smallImages?: string[];

    // Key Takeaways
    keyTakeawaysTitle?: string;
    keyTakeawaysContent?: string;

    // Video
    videoUrl?: string;

    style?: ProblemSolutionBlockStyle;
}

export default function ProblemSolutionBlock({
    title,
    challenges = [],
    problemTitle = "Problem",
    problemContent,
    solutionTitle = "Solution",
    solutionContent,
    mainImage,
    smallImages = [],
    keyTakeawaysTitle = "Key Takeaways",
    keyTakeawaysContent,
    videoUrl,
    style
}: ProblemSolutionBlockProps) {
    // Backward Compatibility: Construct challenges from legacy props if challenges array is empty
    const displayChallenges = challenges.length > 0 ? challenges : [
        ...(problemContent ? [{ title: problemTitle, content: problemContent }] : []),
        ...(solutionContent ? [{ title: solutionTitle, content: solutionContent }] : [])
    ];
    return (
        <div
            className="w-full work-challenges-section"
            style={{
                backgroundColor: style?.backgroundColor || "#FFFFFF",
                paddingTop: style?.paddingTop || "6rem",
                paddingBottom: style?.paddingBottom || "0rem", // Video usually touches bottom or has its own spacing
                color: style?.textColor || "#1F2937"
            }}
        >
            <div className="container mx-auto px-4 md:px-12 lg:px-24">
                {/* 1. Challenges Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
                    {/* Left: Title */}
                    <div className="lg:col-span-4 self-start">
                        <h2
                            className="text-4xl md:text-5xl font-medium tracking-tight mb-8"
                            style={{ color: style?.titleColor || "#000000" }}
                        >
                            {title}
                        </h2>
                    </div>

                    {/* Right: Rich Text Content */}
                    <div className="lg:col-span-7 lg:col-start-6">
                        <div className="prose prose-lg max-w-none hover:prose-a:text-blue-500">
                            {displayChallenges.map((item, idx) => (
                                <div key={idx} className="mb-12 last:mb-0">
                                    {item.title && (
                                        <h3
                                            className="text-xl font-normal mb-4 uppercase tracking-wide"
                                            style={{ color: style?.subtitleColor || "#9CA3AF" }}
                                        >
                                            {item.title}
                                        </h3>
                                    )}
                                    <div
                                        className="text-xl md:text-2xl leading-relaxed font-normal"
                                        dangerouslySetInnerHTML={{ __html: item.content }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
}
